import PapercutApi, { PAPERCUT_API_URL } from '@/api/base/PapercutApi'
import cateringOrderBackend from '@/api/base/cateringOrderBackend'

export default {
  createOrders(orders, params) {
    const { api, paths } = cateringOrderBackend()
    return api.post(paths.orders(), { ...params, orders })
  },
  updateOrderReferredBy(orderId, referredBy, marketingChannels) {
    const { api, paths } = cateringOrderBackend()
    return api.patch(paths.orderReferredBy(orderId), { referredBy, marketingChannels })
  },
  // Stays on Papercut: thin proxy to Spine promo validation + a Papercut Meal
  // lookup — neither source moves (GRAIN-2156).
  initialPromoCodeValidation(promoCode, orders, customer, total) {
    return PapercutApi.post(`${PAPERCUT_API_URL}/orders/initial_promo_code_validation`, { promoCode, orders, customer, total })
  }
}
